/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgVoiceOn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="#1f1f1f" {...props}>
    <path fill="none" d="M0 0h20v20H0z" />
    <circle cx={8} cy={8} r={3} />
    <path d="M13.03 13.37C11.56 12.5 9.84 12 8 12s-3.56.5-5.03 1.37c-.61.35-.97 1.02-.97 1.72V17h12v-1.91c0-.7-.36-1.37-.97-1.72M16.66 1 15.6 2.06c2.53 2.53 2.53 6.66 0 9.19l1.06 1.06c3.12-3.12 3.12-8.19 0-11.31" />
    <path d="m14.54 3.12-1.06 1.06a3.513 3.513 0 0 1 0 4.95l1.06 1.06a5.003 5.003 0 0 0 0-7.07" />
  </svg>
)
export default SvgVoiceOn
